const initialFirstPerson = {
  firstName: 'Barbara',
  lastName: 'Hepworth',
  email: 'bhepworth@sculpture.com',
};

export { initialFirstPerson };
